import React, { useState, useEffect, useCallback } from 'react'
import CompaniesList from '../components/companies/Companies';
import SearchFilter from '../components/companies/SearchFilter';
import CreateCustomer from '../components/companies/CreateCustomer';
import { getCustomersCount } from '../api/pocketbase';

const CompaniesPage = () => {
  const [customerCount, setCustomerCount] = useState(0);
  const [isLoadingCount, setIsLoadingCount] = useState(true);

  const fetchCustomerCount = useCallback(async () => {
    try {
      setIsLoadingCount(true);
      const count = await getCustomersCount();
      setCustomerCount(count);
    } catch (error) {
      console.error('Error fetching customer count:', error);
      setCustomerCount(0);
    } finally {
      setIsLoadingCount(false);
    }
  }, []);

  useEffect(() => {
    fetchCustomerCount();
  }, [fetchCustomerCount]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top Bar - Matching Dashboard style */}
      <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between px-4 sm:px-6 md:px-10 py-4 sm:py-6 bg-white shadow-sm rounded-bl-3xl rounded-br-3xl mb-6 sm:mb-8 gap-4 sm:gap-0">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">Customers</h1>
        <div className="flex items-center gap-2 sm:gap-4 w-full sm:w-auto">
          <CreateCustomer onCreated={fetchCustomerCount} />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-2 sm:px-4 md:px-10 pb-6 sm:pb-10 w-full">
        {/* Filters Section */}
        <div className="bg-white rounded-xl p-6 mb-6">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h3 className="text-gray-900 font-bold text-lg">Customer Management</h3>
              <p className="text-gray-500 text-sm mt-1">View and manage all customer accounts</p>
            </div>
            <div className="text-sm text-gray-500">
              Total customers: <span className="font-semibold text-[#90c740]">
                {isLoadingCount ? '...' : customerCount}
              </span>
            </div>
          </div>
          <SearchFilter />
        </div>

        {/* Table Section */}
        <div className="bg-white rounded-xl shadow-sm">
          <CompaniesList />
        </div>
      </main>
    </div>
  )
}

export default CompaniesPage;
